import veterinaryDog from '@assets/images/veterinary-dog.webp';



const VeterinaryBox = (): JSX.Element => {

	return (
		<div className='veterinary-box'>
			
			<div className='veterinary-photo'>
				<img src={veterinaryDog} alt='veterinary-photo-dog' />
			</div>

			<div className='veterinary-text'>
				
				<p>„Celkový komfort pacienta po operaci, ošetření či v&nbsp;průběhu hojení je jedním ze&nbsp;základních předpokladů dosažení uspokojivých výsledků v&nbsp;péči o naše čtyřnohé mazlíčky. Tento typ ochranné pomůcky je důležitým prvkem na&nbsp;cestě k&nbsp;uzdravení. Palec nahoru našeho pracoviště je u VETlímců známkou kvality podloženou zkušenostmi a&nbsp;množstvím spokojených pacientů.“</p>
				
				<p>MVDr. František Zahrádka</p>
			
			</div>
		
		</div>
	);
};

export default VeterinaryBox;